import { render, staticRenderFns } from "./FormDetailUi.vue?vue&type=template&id=0cf2a3c0&scoped=true&"
import script from "./FormDetailUi.vue?vue&type=script&lang=js&"
export * from "./FormDetailUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf2a3c0",
  null
  
)

export default component.exports